'use client';

import {useRouter} from 'next/navigation';
import {useEffect, useState} from 'react';

const MOBILE_BREAKPOINT = 768;

// useMobileRedirectModal decides once, on mount, whether to render a modal
// inline or hand off to a full page on small screens. On mobile (< 768px) it
// navigates to redirectPath and calls onClose; otherwise it returns true so the
// caller renders the modal. Pass redirectPath=null to never redirect (always
// mount) — e.g. when there's no full-page route to fall back to.
export function useMobileRedirectModal(
  redirectPath: string | null,
  onClose: () => void,
): boolean {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (redirectPath && window.innerWidth < MOBILE_BREAKPOINT) {
      router.push(redirectPath);
      onClose();
      return;
    }
    setMounted(true);
    return () => setMounted(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return mounted;
}
